import {NavigateOptions, useSearchParams, URLSearchParamsInit} from "react-router-dom";

export type SetURLSearchParams = (
  nextInit?: URLSearchParamsInit | ((prev: URLSearchParams) => URLSearchParamsInit),
  navigateOpts?: NavigateOptions,
) => void;
type UseFixedSearchParamsReturnTuple = [URLSearchParams, SetURLSearchParams];

// Simple wrapper around useSearchParams from react-router-dom v6
export const useFixedSearchParams = (): UseFixedSearchParamsReturnTuple => {
  return useSearchParams();
};
